module.exports = __webpack_public_path__ + "fonts/Euclid Circular B Light Italic.8a42ba91.woff";